import { ActivityLogType, EventActionName, EventAlarmStatus, EventInteractionStatus, EventSourceType } from 'Utils/API/types/omniaPreventController';
export const EventHandlerServiceSubmitter = 'Event Handler Service';
/**
 * Application events data query keys
 * @constant {Object}
 */
export var EventsDataQueryKeys;
(function (EventsDataQueryKeys) {
    EventsDataQueryKeys["STREAM"] = "stream_events";
    EventsDataQueryKeys["LIST"] = "list_events";
    EventsDataQueryKeys["OVERVIEW"] = "overview_events";
})(EventsDataQueryKeys || (EventsDataQueryKeys = {}));
/**
 * Event Item Default
 * same nested structure as from an API but with default values
 * @constant {Object}
 */
export const eventDefaultValues = {
    source_node_id: 'string',
    title: 'string',
    source_type: EventSourceType.Manual,
    start_timestamp: '2021-08-24T20:10:08.858Z',
    end_timestamp: '2021-08-24T20:10:08.858Z',
    actions: [EventActionName.RedefineTrainingPeriod, EventActionName.ExcludeFromTrainingPeriod],
    action_info: {
        redefine_training_period: [
            {
                text: 'Notes.'
            },
            {
                start: '2021-06-28T15:17:12.240Z',
                end: '2021-06-28T15:17:12.240Z'
            },
            {
                start: '2021-06-28T15:17:12.240Z',
                end: '2021-06-28T15:17:12.240Z'
            }
        ],
        exclude_from_training_period: [
            {
                start: '2021-06-28T15:17:12.240Z',
                end: '2021-06-28T15:17:12.240Z'
            },
            {
                text: 'Additional notes.'
            }
        ],
        add_to_training_period: [
            {
                start: '2021-06-28T15:17:12.240Z',
                end: '2021-06-28T15:17:12.240Z'
            },
            {
                text: 'Additional notes.'
            }
        ]
    },
    submitter: 'string',
    updated_by: 'string',
    updated_timestamp: '2021-08-24T20:10:08.858Z',
    interaction_status: EventInteractionStatus.New,
    model_id: 0,
    concerning_anomaly: true,
    culprit_tags: [
        {
            name: '1903.R-29TE3001.MA_Y',
            time_series_id: 'd489d3-208b-4dc3-9393-5271'
        }
    ],
    version: 0,
    id: 0,
    equipment_id: 'dd198224-2836-4bae-86bf-20386d4c0e38-9999',
    equipment_version: 1,
    creation_timestamp: '2021-08-24T20:10:08.858Z',
    alarm_status: EventAlarmStatus.Inactive,
    hierarchy: ['Asset', 'System', 'Machine', 'Folder'],
    model_owner: 0,
    activity_logs: [
        {
            type: ActivityLogType.Comment,
            entry: 'string',
            submitter: 'string',
            timestamp: '2021-08-24T20:10:08.858Z'
        }
    ],
    annotation_id: '0',
    engineer_user: 'engineer@equinor.com',
    data_scientist_user: 'data_scientist@equinor.com'
};
/**
 * Event Filters Empty
 * @constant {Object}
 */
export const eventFiltersEmpty = {
    ownershipOptions: {
        model_owner: []
    },
    eventsOptions: {
        title: '',
        alarm_status: [],
        interaction_status: [],
        period: { start: '', end: '' },
        concerning_anomaly: [],
        action: [],
        engineer_user: [],
        data_scientist_user: []
    },
    hierarchyOptions: {
        path: [],
        root_nodes: []
    }
};
/**
 * Event Filters Default
 * @constant {Object}
 */
export const eventsFiltersDefault = {
    ownershipOptions: {
        model_owner: []
    },
    eventsOptions: {
        title: '',
        alarm_status: [],
        interaction_status: [],
        period: { start: '', end: '' },
        concerning_anomaly: [],
        action: [],
        engineer_user: [],
        data_scientist_user: []
    },
    hierarchyOptions: {
        path: [],
        root_nodes: []
    }
};
/**
 * Event Active Statuses
 * @constant {Array}
 * @type {Array<EventInteractionStatus>}
 * @description List of active event statuses
 */
export const EventActiveStatuses = [
    EventInteractionStatus.New,
    EventInteractionStatus.MonitoringWatchlist,
    EventInteractionStatus.ReadyForTraining,
    EventInteractionStatus.Trained
];
